import React from 'react'
import { components } from 'react-select'

import styled from 'styled-components'

import { palette } from '_styles/variables'

const Message = styled.span<{ hasMessage?: boolean }>`
  ${({ hasMessage }) =>
    hasMessage
      ? {
          margin: 0,
          fontFamily: 'Regular, sans-serif',
          fontSize: '1rem',
          fontWeight: '500',
          lineHeight: '22px',
          color: `${palette.neutral['primary-body']}`,
        }
      : {}}
`

const defaultMessage = 'No options'

export const getNoOptionsMessage = (message = defaultMessage) =>
  (props => (
    <components.NoOptionsMessage {...props}>
      <Message hasMessage={message !== defaultMessage}>{message}</Message>
    </components.NoOptionsMessage>
  )) as typeof components.NoOptionsMessage
